import { createRef, useState, useEffect } from 'react';
import FilterRule from './FilterRule';
import {
	getSettings,
	setSetting,
	watchSettings,
	unwatchSettings
} from '../utils/eventViewerSettings';
import toJSON from '../utils/toJSON';

export default function Filters() {
	const keyInput = createRef();
	const conditionSelect = createRef();
	const valueInput = createRef();

	const [filters, setFilters] = useState(getSettings().filters);

	useEffect(() => {
		const settingsChangeHandler = (newSettings) => {
			if (toJSON(newSettings.filters) !== toJSON(filters)) {
				setFilters(newSettings.filters);
			}
		};
		watchSettings(settingsChangeHandler);
		return function cleanup() {
			unwatchSettings(settingsChangeHandler);
		};
	});

	const addFilter = (event) => {
		event.preventDefault();
		if (keyInput.current && conditionSelect.current && valueInput.current) {
			const filter = {
				key: keyInput.current.value,
				condition: conditionSelect.current.value,
				value: valueInput.current.value
			};
			const newFilters = [...filters, filter];
			keyInput.current.value = '';
			conditionSelect.current.value = 'is exactly';
			valueInput.current.value = '';
			setSetting('filters', newFilters);
		}
	};
	const removeFilter = (filter) => {
		const filtersClone = [...filters];
		const index = filtersClone.indexOf(filter);
		if (index > -1) {
			filtersClone.splice(index, 1);
			setSetting('filters', filtersClone);
		}
	};

	return (
		<>
			<h3>Filters</h3>
			<ul className="ws-tagging-ev-Filters">
				{filters.map((filter) => (
					<FilterRule
						key={JSON.stringify(filter)}
						filter={filter}
						onRemove={removeFilter}
					/>
				))}
			</ul>
			<form onSubmit={addFilter}>
				<div className="row">
					<div className="col col-md-3">
						<input
							ref={keyInput}
							className="ws-tagging-ev-Filter-key form-control"
							placeholder="Key"
						/>
					</div>
					<div className="col col-md-3">
						<select
							ref={conditionSelect}
							className="ws-tagging-ev-Filter-condition form-control"
						>
							<option>is exactly</option>
							<option>contains</option>
							<option>is not</option>
							<option>does not contain</option>
							<option>starts with</option>
							<option>ends with</option>
							<option>does not start with</option>
							<option>does not end with</option>
						</select>
					</div>
					<div className="col col-md-4">
						<input
							ref={valueInput}
							className="ws-tagging-ev-Filter-value form-control"
							placeholder="Value"
						/>
					</div>
					<div className="col col-md-2">
						<button type="submit" className="btn">
							Add Filter
						</button>
					</div>
				</div>
			</form>
		</>
	);
}

Filters.propTypes = {};
